/**
 * Shared server error-`detail` string contract (CHP-1112).
 *
 * These MUST stay byte-identical to the backend
 * (`apps/api/src/prm_api/error_details.py`). The web client matches them to turn
 * hand-thrown 422 `detail` strings into actionable copy; a drift silently breaks
 * that handling. Defined once here so consumers import rather than re-type the
 * literal.
 */

/** routers/deals.py — on-behalf create guard (CHP-458). */
export const TARGET_BDM_ID_REQUIRED = "target_bdm_id required when creating on behalf";

/** services/deal_workflow.py — incomplete-draft submit (CHP-474). The full
 * detail is this prefix followed by a comma-joined list of missing field names.
 * The trailing space is part of the contract. */
export const INCOMPLETE_DEAL_MISSING_PREFIX = "incomplete deal: missing ";
